import { Button, Layout, Space } from "antd";
import { useState, useEffect } from "react";
import { CreateAirSzzJournalDto, AirSzzJournal, UpdateAirSzzJournalDto } from "../../api";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { EditableTable } from "../../components/editable-table/EditableTable";
import { AirSzzJournalsForm } from "./components/AirSzzJournalsForm";
import { AirSzzJournalsColumns } from "./form/columns";
import { createAirSzzJournalAsync, updateAirSzzJournalAsync, selectAirSzzJournals, deleteAirSzzJournalAsync, fetchAirSzzJournalsByQuarterAsync } from "./AirSzzJournalsSlice";
import { BASE_PATH } from "../../api/base";
import { fetchAirSzzPointsByOrganizationidAsync } from "../airSzzPoints/AirSzzPointsSlice";
import { AirSzzJournalForm } from "./components/AirSzzJournalForm";

interface AirSzzJournalsComponentProps {
  organizationId?: string;
  year: number;
  quarter: number;
}

export const AirSzzJournalsComponent: React.FC<AirSzzJournalsComponentProps> = ({ organizationId, year, quarter }) => {
  const dispatch = useAppDispatch();
  const journals = useAppSelector(selectAirSzzJournals);
  const airSzzJournals = journals.map((journal) => (
    {
      ...journal,
      point: `№${journal?.pollutant?.point?.no} ${journal?.pollutant?.point?.name} (${journal?.pollutant?.point?.latitude}° ш. ${journal?.pollutant?.point?.longitude}° д.)` || undefined,
    }));

  const [visibleForms, setFormsVisible] = useState(false);
  const [visibleForm, setFormVisible] = useState(false);

  useEffect(() => {
    if (organizationId) {
      if (year && quarter) {
        dispatch(fetchAirSzzJournalsByQuarterAsync({ organizationId, year, quarter }));
      } else {
        dispatch(fetchAirSzzJournalsByQuarterAsync({ organizationId, year: new Date().getFullYear(), quarter: Math.ceil(new Date().getMonth() / 3) }));
      }

      dispatch(fetchAirSzzPointsByOrganizationidAsync(organizationId));
    }
  }, [year, quarter, organizationId, dispatch]);

  const onUpdate = async (airSzzJournal: UpdateAirSzzJournalDto, id: string) => {
    return dispatch(updateAirSzzJournalAsync({ airSzzJournal, id })).then((res: any) => {
      if (!res.error) {
        if (organizationId) {
          if (year && quarter) {
            dispatch(fetchAirSzzJournalsByQuarterAsync({ organizationId, year, quarter }));
          } else {
            dispatch(fetchAirSzzJournalsByQuarterAsync({ organizationId, year: new Date().getFullYear(), quarter: Math.ceil(new Date().getMonth() / 3) }));
          }
        }
        return true;
      }
      return false;
    });
  };

  const onCreateAirSzzJournal = (airSzzJournal: CreateAirSzzJournalDto) => {
    if (!organizationId || !year || !quarter) return;

    dispatch(createAirSzzJournalAsync({ ...airSzzJournal, organizationId, year, quarter })).then((res: any) => {
      if (!res.error) {
        setFormVisible(false);
        setFormsVisible(false);
      }
    });
  };

  const deleteAirSzzJournals = (airSzzJournal: AirSzzJournal) => {
    return dispatch(deleteAirSzzJournalAsync({ airSzzJournal })).then((res: any) => {
      if (!res.error) {
        return true;
      }
      return false;
    });
  }

  const addButtons = (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Button onClick={() => setFormVisible(true)} block type="dashed" className="">
        + Добавить запись в журнал
      </Button>
      <Button onClick={() => setFormsVisible(true)} block type="dashed">
        + Добавить несколько записей в журнал
      </Button>
    </Space>
  )

  return (
    <Layout className="bg-white p-4 rounded-lg">
      {visibleForms && <AirSzzJournalsForm visible={visibleForms} setVisible={setFormsVisible} onCreateAirSzzJournal={onCreateAirSzzJournal} organizationId={organizationId} />}
      {visibleForm && <AirSzzJournalForm visible={visibleForm} setVisible={setFormVisible} onCreateAirSzzJournal={onCreateAirSzzJournal} organizationId={organizationId} />}
      <div className="table-responsive">
        <EditableTable<AirSzzJournal, UpdateAirSzzJournalDto>
          onSave={onUpdate}
          onDelete={deleteAirSzzJournals}
          entityColumns={AirSzzJournalsColumns()}
          dataSource={airSzzJournals}
          footer={() => addButtons}
        />
      </div>
      <Button href={`${BASE_PATH}/air-szz-journal/report/organization/${organizationId}`} block type="primary" ghost>
        Получить отчёт
      </Button>
    </Layout>
  );
};
